import RemoveAdjustmentDialog from './RemoveAdjustmentDialog';

export default RemoveAdjustmentDialog;
